import React, { Component, Form, Label, Input } from "react";
import { Row, Col, Button, Container, Image } from "react-bootstrap";
import "./Personnel.css";
import Icon from "react-fa";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

class Personnel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serveur: { tabServeur: [], referent: {} },
      email: "",
      modalReferent: false,
      indexRef: 0,
      general: false,
      restaurantName: "",
      adress: "",
      postal: "",
      city: "",
      modalDelete: false,
      serveurToDelete: null,
      feedback: null,
    };

    this.hideModal = this.hideModal.bind(this);
  }

  popupModal = () => {
    const handleClose = () => this.setState({ modalReferent: false });

    return (
      <>
        <Modal
          show={this.state.modalReferent}
          onHide={handleClose}
          animation={true}
          backdrop={true}
          keyboard={false}
          style={{ overlay: { zIndex: 3 } }}>
          <Modal.Header>
            <Modal.Title>Modifier votre référent</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="affiPop">
              <Col s={12} md={12}>
                <p>
                  C'est lui qui remplacera votre référent actuel et qui
                  répartira le pot commun aux équipes,
                  <br />
                  selon vos règles.
                  <br />
                  Envoyez lui un mail pour le désigner.
                  <br />
                </p>
              </Col>
              <Col>
                <input
                  type="submit"
                  value="Envoyer un mail"
                  onClick={() => {
                    this.addReferent(
                      this.state.serveur.tabServeur[this.state.indexRef]
                        .serveurMail
                    );
                  }}
                  className="button"
                />
              </Col>
              <Col s={12} md={12}>
                <p>
                  <br />À réception du mail, le référent pourra commencer à
                  répartir.
                </p>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </>
    );
  };

  hideModal = () => {
    this.setState({ modalReferent: false });
  };

  getWaiterList = () => {
    const headers = new Headers({
      Authorization: "bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/restaurateur/management/waiter-list",
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (data) => {
          this.setState({ serveur: data });
        },
        (err) => {
        }
      );
  };

  showFeedback = (type, text) => {
    this.setState({ feedback: { type, text } });
    if (this.feedbackTimer) clearTimeout(this.feedbackTimer);
    this.feedbackTimer = setTimeout(
      () => this.setState({ feedback: null }),
      4000
    );
  };

  askDeleteWaiter = (serveur) => {
    this.setState({ serveurToDelete: serveur, modalDelete: true });
  };

  closeDeleteConfirm = () => {
    this.setState({ modalDelete: false, serveurToDelete: null });
  };

  confirmDeleteWaiter = () => {
    const serveur = this.state.serveurToDelete;
    if (!serveur) return;

    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ mail: serveur.serveurMail }),
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/restaurateur/management/waiter-delete",
      options
    )
      .then((response) => {
        return response.json();
      })
      .then(
        () => {
          this.closeDeleteConfirm();
          // Rafraîchit la liste et l'état du référent sans recharger la page
          this.getWaiterList();
          this.getRestaurantName();
          this.showFeedback(
            "success",
            `${serveur.serveurName} ${serveur.serveurLastName} a bien été retiré de votre équipe.`
          );
        },
        () => {
          this.closeDeleteConfirm();
          this.showFeedback(
            "error",
            "La suppression a échoué, veuillez réessayer."
          );
        }
      );
  };

  renderAvatar = (element) => {
    const initials = (
      ((element.serveurName || "")[0] || "") +
      ((element.serveurLastName || "")[0] || "")
    ).toUpperCase();

    return (
      <div className="serveurAvatar">
        <span className="serveurInitials">{initials || "?"}</span>
        {element.serveurPicture ? (
          <Image
            className="serverPicture"
            src={
              process.env.REACT_APP_BACKEND_URL + element.serveurPicture
            }
            roundedCircle
            // Si la photo ne charge pas, on laisse apparaître l'avatar à initiales
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = "none";
            }}
          />
        ) : null}
      </div>
    );
  };

  renderMesServeurs = () => {
    return this.state.serveur?.tabServeur?.map((element, index) => {
      const isReferent =
        this.state.serveur?.referent?.email === element.serveurMail;
      return (
        <div
          className={"serveurCard" + (isReferent ? " serveurCardRef" : "")}
          key={element.serveurMail || index}>
          {isReferent ? <span className="refBadge">⭐ Référent</span> : null}

          {this.renderAvatar(element)}

          <p className="serveurNom">
            {element.serveurName} {element.serveurLastName}
          </p>
          {element.serveurPoste ? (
            <p className="serveurPoste">{element.serveurPoste}</p>
          ) : null}

          {isReferent ? null : (
            <button
              className="buttonDesignerRef"
              onClick={() =>
                this.setState({ indexRef: index, modalReferent: true })
              }>
              Désigner référent
            </button>
          )}
          <button
            className="buttonSupprimer"
            onClick={() => this.askDeleteWaiter(element)}>
            Supprimer
          </button>
        </div>
      );
    });
  };
  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getRestaurantName = () => {
    const headers = new Headers({
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),

      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurant", options)
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {

          /**
           * Condition: SI il n'y a pas de référent on ne modifie pas le mail
           */
          responseObject.referent
            ? this.setState({ email: responseObject.referent.email })
            : this.setState({ email: "" });

          this.setState({ general: responseObject.pourboireGeneral });
          this.setState({
            restaurantName: responseObject.restaurantName,
            adress: responseObject.adress,
            postal: responseObject.postal,
            city: responseObject.city,
          });
        },

        (error) => {
        }
      );
  };

  addAffiliation = (e) => {
    e.preventDefault();
    const data = {
      email: this.state.email,
    };

    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "POST",
      body: JSON.stringify(data),
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/restaurateur/management/affiliation",
      options
    )
      .then((response) => {
        return response.json();
      })

      .then((responseData) => {
        if (responseData === true) {
          alert("Votre demande a bien été prise en compte");
        } else {
          alert(responseData.messageAffi);
        }
      });
  };
  addReferent = (e) => {
    //e.preventDefault();
    const data = {
      email: this.state.serveur?.tabServeur[this.state.indexRef]?.serveurMail,
    };

    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "POST",
      body: JSON.stringify(data),
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/restaurateur/management/referent",
      options
    )
      .then((response) => {
        return response.json();
      })

      .then((responseData) => {
        this.setState({ message: responseData.message });
      })
      .then(() => {
        this.hideModal();
      });
  };
  deleteModal = () => {
    const s = this.state.serveurToDelete;
    return (
      <Modal
        show={this.state.modalDelete}
        onHide={this.closeDeleteConfirm}
        animation={true}
        centered>
        <Modal.Header>
          <Modal.Title>Supprimer ce bénéficiaire</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Voulez-vous vraiment retirer{" "}
          <strong>{s ? `${s.serveurName} ${s.serveurLastName}` : ""}</strong> de
          votre équipe&nbsp;? Cette action est irréversible.
        </Modal.Body>
        <Modal.Footer>
          <Button className="buttonNonRef" onClick={this.closeDeleteConfirm}>
            Annuler
          </Button>
          <Button className="button" onClick={this.confirmDeleteWaiter}>
            Confirmer la suppression
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  componentDidMount() {
    this.getWaiterList();
    this.getRestaurantName();
  }

  componentWillUnmount() {
    if (this.feedbackTimer) clearTimeout(this.feedbackTimer);
  }

  crew = () => {
    if (
      !this.state.serveur ||
      !this.state.serveur.tabServeur ||
      this.state.serveur.tabServeur.length === 0
    ) {
      return (
        <p className="affiliation">Vous n'avez pas de personnel affilié</p>
      );
    }
    return (
      <Col className="crewStyle">
        <div className="crewGrid">{this.renderMesServeurs()}</div>
      </Col>
    );
  };

  render() {
    return (
      <Container className="container personnel">
        {this.state.feedback ? (
          <div className={"feedbackBanner " + this.state.feedback.type}>
            {this.state.feedback.text}
          </div>
        ) : null}
        <div className="restaurantHeader">
          <span className="restaurantHeaderName">
            {this.state.restaurantName}
          </span>
          {this.state.adress || this.state.postal || this.state.city ? (
            <span className="restaurantHeaderAdress">
              {" "}
              —{" "}
              {[
                this.state.adress,
                [this.state.postal, this.state.city]
                  .filter(Boolean)
                  .join(" "),
              ]
                .filter(Boolean)
                .join(", ")}
            </span>
          ) : null}
          <div>
            <Link className="editRestaurantButton" to="/Profil">
              Éditer les données du restaurant
            </Link>
          </div>
        </div>
        <Row>
          <Col>
            <Link className="linkButton" to="/equipe">
              <h1 className="title-container">Gestion de mon équipe</h1>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col className="colAffiliation">
            <Col md={12}>
              <label className="demandeAffiliation">
                Ajouter un bénéficiaire dans mon équipe
              </label>
            </Col>
            {!this.state.email ||
            (this.state.email === "" && this.state.general === true) ? (
              <p>
                Vous devez désigner un référent pour pouvoir rajouter de
                nouveaux bénéficiaires
              </p>
            ) : (
              <Col>
                <input
                  type="text"
                  name="email"
                  onChange={this.handleInput}
                  placeholder="Bénéficiaire"
                  className="inputAffi"
                />

                <input
                  type="submit"
                  value="Envoyer la demande"
                  onClick={this.addAffiliation}
                  className="button"
                />
                <p className="infoAffi">
                  Si votre bénéficiaire n'est pas encore inscrit sur la
                  plateforme Tipourboire, il recevra un mail afin de valider son
                  inscription et compléter son compte. Le bénéficiaire doit
                  valider votre demande afin d'être référencé dans votre équipe.
                  Vous pourrez alors le visualiser.
                </p>
              </Col>
            )}

            {this.state.messageAffi}
          </Col>
        </Row>
        <h1 className="titleWaiter">Mon équipe </h1>
        <p className="centerRef">
          Si vous avez déjà désigné un référent et envoyé une demande à
          celui-ci, vous n'avez pas à le saisir de nouveau dans votre équipe.
        </p>
        {this.crew()}
        <Row className="centerRef">
          <Col>
            <p>
              {" "}
              Vous pouvez changer de référent à tout moment en cliquant sur le
              bouton "non référent" du bénéficiaire que vous avez choisi pour
              répartir le pot commun.
            </p>
          </Col>
        </Row>
        {this.popupModal()}
        {this.deleteModal()}
      </Container>
    );
  }
}

export default Personnel;
